export const STATE_UPDATED = 'stateChanged';

export const UI_OFFCANVAS_TOGGLED = 'uiOffCanvasToggled';
export const UI_OFFCANVAS_SHOWN = 'uiOffCanvasShown';
export const UI_OFFCANVAS_HIDDEN = 'uiOffCanvasHidden';
export const UI_SEARCH_TOGGLED = 'uiSearchToggled';
export const UI_SEARCH_SHOWN = 'uiSearchShown';
export const UI_SEARCH_HIDDEN = 'uiSearchHidden';
export const UI_ACTIVE_MODAL_CHANGED = 'uiModalChanged';
export const UI_FIXED_SCROLLBAR = 'uiFixedScrollbar';
export const UI_UNFIXED_SCROLLBAR = 'uiUnfixedScrollbar';

export const CART_UPDATED = 'cartChanged';
export const ADDED_ITEM_TO_CART = 'addedItemToCart';
export const REMOVED_ITEM_FROM_CART = 'removedItemFromCart'; 

export const WISHLIST_UPDATED = 'wishlistChanged';
export const ADDED_ITEM_TO_WISHLIST = 'addedItemToWishlist';
export const REMOVED_ITEM_FROM_WISHLIST = 'removedItemFromWishlist'; 

export const COMPARE_UPDATED = 'compareChanged';
export const ADDED_ITEM_TO_COMPARE = 'addedItemToCompare';
export const REMOVED_ITEM_FROM_COMPARE = 'removedItemFromCompare'; 

export const LOCATION_CHANGED = 'locationChanged';
export const LOCATION_CONFIRMED = 'locationConfirmed';